import bingoAdvanceTable from './index.vue';
export default bingoAdvanceTable;



// WEBPACK FOOTER //
// ./src/components/bingo-advance-table/index.js